import LegalPageLayout, { LegalSection } from "@/components/LegalPageLayout";
import { PHONE_DISPLAY, EMAIL } from "@/constants/business";

export default function ReclamationsPage() {
  return (
    <LegalPageLayout
      title="Réclamations"
      path="/reclamations"
      description="Procédure de réclamation auprès d'Express Delivery : contact, délais et médiation."
      testId="reclamations-page"
    >
      <LegalSection title="Comment nous adresser une réclamation ?">
        <p>Si une prestation ne s'est pas déroulée comme prévu, contactez-nous :</p>
        <ul className="list-disc pl-5 space-y-1 mt-2">
          <li>par téléphone au {PHONE_DISPLAY} ;</li>
          <li>par email à {EMAIL}, en précisant la date de la prestation et le motif de la réclamation.</li>
        </ul>
      </LegalSection>
      <LegalSection title="Traitement">
        <p>
          Chaque réclamation est étudiée avec attention. Une réponse écrite vous est apportée dans les meilleurs
          délais. Joindre si possible des photos et tout élément utile à l'étude du dossier.
        </p>
      </LegalSection>
      <LegalSection title="Médiation de la consommation">
        <p>
          Conformément à la réglementation applicable, le consommateur peut recourir gratuitement à un médiateur de
          la consommation en cas de litige non résolu. Les coordonnées du médiateur compétent sont communiquées sur
          simple demande auprès de nos services.
        </p>
      </LegalSection>
    </LegalPageLayout>
  );
}
